var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4231 13.2071C20.9689 12.939 20.4017 12.9968 20.0125 13.3511C18.9335 14.3342 17.5293 14.8757 16.0591 14.8757C12.8445 14.8757 10.2301 12.2966 10.2301 9.1277C10.2301 7.10582 11.3273 5.21001 13.094 4.1775C13.5492 3.91149 13.7678 3.39313 13.6377 2.88634C13.5077 2.38061 13.0652 2.02733 12.5363 2.00736C12.4052 2.0021 12.2719 2 12.1408 2C6.54958 2 2 6.48643 2 12C2 17.5136 6.54958 22 12.1408 22C16.7714 22 20.8092 18.9151 21.9616 14.4992C22.0938 13.9935 21.8773 13.4752 21.4231 13.2071ZM12.1405 20.4094C7.43837 20.4094 3.61293 16.6368 3.61293 12.0002C3.61293 7.71021 6.88728 4.15966 11.1011 3.65283C10.519 4.16591 10.0178 4.76838 9.62333 5.43709C8.9644 6.55264 8.61576 7.82908 8.61576 9.12653C8.61576 13.1734 11.9551 16.4666 16.0592 16.4666C17.4474 16.4666 18.7887 16.0892 19.951 15.3847C18.6107 18.3991 15.5687 20.4095 12.1409 20.4095L12.1405 20.4094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.dd964e5ea1b692794b613e9f373b1f5e.svg";
export { ForwardRef as ReactComponent };